import { useState, useRef } from 'react';
import {
  Tabs,
  Tab,
  Toolbar,
  Autocomplete,
  TextField,
  Grid,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
  CircularProgress,
  autocompleteClasses,
  Box,
  Chip,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Popper,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { TitleTotalTab, TitleTotalTabProps } from './tabs/TitleTotalTab';
import { TabSelection } from './TabSelection';

export interface TableFilter {
  options: any[];
  label?: string;
  defaultOption: any;
  onChange: (event: React.SyntheticEvent, newValue: any | null) => void;
  loading?: boolean;
}

export interface TabIndexTableToolbarProps {
  accordian?: boolean;
  value: number;
  filters?: TableFilter[][];
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  tabs: { [key: string]: TitleTotalTabProps };
  setTabs: (tabs: { [key: string]: TitleTotalTabProps }) => void;
  resetTabs: Function;
  configLoading: boolean;
  config: boolean;
}

export const TabIndexTableToolbar = (props: TabIndexTableToolbarProps) => {
  const {
    tabs,
    setTabs,
    resetTabs,
    configLoading,
    value,
    filters = [],
    handleChange,
    accordian = false,
    config,
  } = props;
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleMenuItemClick = (event: any, index: number) => {
    handleChange(event, index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };
  const sortedTabs = [...Object.values(tabs)]?.sort(
    (a, b) => a.sequence - b.sequence
  );
  return (
    <>
      <Toolbar sx={{ px: { xs: 1, sm: 0 } }} disableGutters>
        {!downMd ? (
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            spacing={2}
            // flexWrap={'nowrap'}
          >
            <Grid item md={12} lg={11} flexGrow={9}>
              <Tabs
                value={value}
                variant={'scrollable'}
                onChange={(event, value) => handleChange(event, value)}
                sx={{
                  width: '100%',
                  '& .MuiTabs-flexContainer': {
                    pl: 0,
                  },
                }}
              >
                {sortedTabs.map((tab, index) => (
                  <Tab
                    id={`tab-${index}`}
                    className={`tab-${index}`}
                    key={index}
                    sx={{ display: tab.visible ? 'block' : 'none' }}
                    label={
                      <TitleTotalTab
                        title={tab.title}
                        total={tab.total}
                        key={tab.key}
                        sequence={tab.sequence}
                      />
                    }
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid
              item
              md={2}
              lg={1}
              // sx={{ marginLeft: 'auto', flex: 1, pb: 2 }}
              // flexWrap={'nowrap'}
            >
              <Grid
                container
                direction="row-reverse"
                alignItems="flex-start"
                spacing={1}
                flexWrap={'nowrap'}
              >
                {false &&
                  filters.map((filter, index) =>
                    filter.map((f, i) => (
                      <Grid
                        item
                        sx={{
                          display: index === value ? 'block' : 'none',
                          flex: downMd ? 1 : 0,
                        }}
                        key={`${i}-${index}`}
                      >
                        <Autocomplete
                          id={`filter-${index}-${i}`}
                          disablePortal
                          disableClearable
                          options={f.options}
                          onChange={(event, value) => f.onChange(event, value)}
                          value={f.defaultOption}
                          getOptionLabel={(option: any) => {
                            if (typeof option === 'string') {
                              return option;
                            } else {
                              return (
                                option?.label ||
                                option?.title ||
                                option?.name ||
                                ''
                              );
                            }
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={f.label || ''}
                              InputProps={{
                                ...params.InputProps,
                              }}
                            />
                          )}
                          popupIcon={
                            f.loading ? (
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 24,
                                  height: 24,
                                }}
                              >
                                <CircularProgress color="inherit" size={18} />
                              </Box>
                            ) : (
                              <ArrowDropDown />
                            )
                          }
                          fullWidth
                          sx={{
                            [`.${autocompleteClasses.inputRoot}`]: {
                              [`.${autocompleteClasses.input}`]: {
                                width: 'fit-content',
                              },
                            },
                          }}
                        />
                        {/* <ControlledAutoComplete {...f} /> */}
                      </Grid>
                    ))
                  )}
                {config && (
                  <Grid item alignSelf={'center'} flex={0}>
                    <TabSelection
                      tabs={tabs}
                      setTabs={setTabs}
                      resetTabs={resetTabs}
                      configLoading={configLoading}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-end"
            // flexWrap={'nowrap'}
          >
            <Grid item flexGrow={2}>
              <Chip
                ref={anchorRef}
                // size="small"
                color="primary"
                label={sortedTabs[value]?.title || 'Select tab'}
                onClick={handleToggle}
                onDelete={handleToggle}
                deleteIcon={<ArrowDropDown />}
                sx={{ width: '100%' }}
              />
            </Grid>
            <Grid item alignSelf={'center'} flex={0}>
              <TabSelection
                tabs={tabs}
                setTabs={setTabs}
                resetTabs={resetTabs}
                configLoading={configLoading}
              />
            </Grid>
            <Popper
              sx={{ zIndex: 10 }}
              open={open}
              anchorEl={anchorRef.current}
              transition
              placement={'bottom-start'}
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper
                    sx={{
                      px: 4,
                      py: 2,
                    }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList autoFocusItem>
                        <small style={{ padding: 1 }}>
                          * select option below
                        </small>
                        {sortedTabs.map((tab, index) => (
                          <MenuItem
                            key={`mobile-tab-${index}`}
                            selected={index === value}
                            onClick={event => handleMenuItemClick(event, index)}
                            sx={{ py: 1.5 }}
                          >
                            {tab.title}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <Grid
              item
              xs={12}
              sx={{ marginLeft: 'auto', flex: 1, py: 2 }}
              flexWrap={'nowrap'}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                spacing={2}
                // flexWrap={'nowrap'}
              >
                {filters.map((filter, index) =>
                  filter.map((f, i) => (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: index === value ? 'block' : 'none',
                        flex: downMd ? 1 : 0,
                      }}
                      key={`${i}-${index}`}
                    >
                      <Autocomplete
                        id={`filter-${index}-${i}`}
                        disablePortal
                        disableClearable
                        options={f.options}
                        onChange={(event, value) => f.onChange(event, value)}
                        value={f.defaultOption}
                        getOptionLabel={(option: any) => {
                          if (typeof option === 'string') {
                            return option;
                          } else {
                            return (
                              option?.label ||
                              option?.title ||
                              option?.name ||
                              ''
                            );
                          }
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            size={'small'}
                            fullWidth
                            label={f.label || ''}
                            InputProps={{
                              ...params.InputProps,
                            }}
                          />
                        )}
                        popupIcon={
                          f.loading ? (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 24,
                                height: 24,
                              }}
                            >
                              <CircularProgress color="inherit" size={18} />
                            </Box>
                          ) : (
                            <ArrowDropDown />
                          )
                        }
                        fullWidth
                        sx={{
                          [`.${autocompleteClasses.inputRoot}`]: {
                            [`.${autocompleteClasses.input}`]: {
                              width: 'fit-content',
                            },
                          },
                        }}
                      />
                      {/* <ControlledAutoComplete {...f} /> */}
                    </Grid>
                  ))
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Toolbar>
    </>
  );
};

const ControlledAutoComplete = (props: TableFilter) => {
  const { defaultOption, options, onChange } = props;
  const [value, setValue] = useState<string | null>();
  // const [initialDefaultValue, setInitialDefaultValue] = useState<string>(defaultValue)
  return (
    <Autocomplete
      disablePortal
      disableClearable
      options={options}
      onChange={(event, value) => onChange(event, value)}
      defaultValue={defaultOption}
      sx={{ width: 200, height: 30 }}
      renderInput={params => (
        <TextField {...params} label={props.label || ''} />
      )}
      value={value || defaultOption}
    />
  );
};
